<section class="container product">
  <div class="product__showcase glass">
    <div class="product__copy">
      <h1 class="product__title">{{ 'products.demoTitle' | translate }}</h1>
      <p class="product__body">{{ 'products.demoP1' | translate }}</p>
      <p class="product__body">{{ 'products.demoP2' | translate }}</p>

      <div class="product__chips" aria-label="Portfolio highlights">
        <span class="product__chip">{{ 'products.chips.pvdc' | translate }}</span>
        <span class="product__chip">{{ 'products.chips.evoh' | translate }}</span>
        <span class="product__chip">{{ 'products.chips.pvdcFree' | translate }}</span>
        <span class="product__chip">{{ 'products.chips.thermoformed' | translate }}</span>
        <span class="product__chip">{{ 'products.chips.pouches' | translate }}</span>
      </div>
    </div>

    <div class="product__media">
      <div class="product__mediaCard glass">
        <img class="product__img" [src]="demoSrc" [alt]="'products.images.demoAlt' | translate" />
      </div>
      <div class="product__mediaCard product__mediaCard--secondary glass">
        <img class="product__img" [src]="demoSecondarySrc" [alt]="'products.images.demoAltSecondary' | translate" />
      </div>
    </div>
  </div>
</section>

<section class="container product-details">
  <div class="product-details__grid">
    <article class="product-card glass">
      <h2 class="product-card__title">{{ 'products.blocks.qualityTitle' | translate }}</h2>
      <p class="product-card__body">{{ 'products.blocks.qualityBody' | translate }}</p>
    </article>

    <article class="product-card glass">
      <h2 class="product-card__title">{{ 'products.blocks.portfolioTitle' | translate }}</h2>
      <p class="product-card__body">{{ 'products.blocks.portfolioBody' | translate }}</p>
    </article>

    <article class="product-card glass">
      <h2 class="product-card__title">{{ 'products.blocks.applicationsTitle' | translate }}</h2>
      <p class="product-card__body">{{ 'products.blocks.applicationsBody' | translate }}</p>
    </article>
  </div>
</section>

<section class="container product-banner">
  <div class="product-banner__inner glass">
    <h2 class="product-banner__title">{{ 'products.bannerTitle' | translate }}</h2>
    <p class="product-banner__body">{{ 'products.bannerBody' | translate }}</p>
    <p class="product-banner__meta">{{ 'products.bannerMeta' | translate }}</p>
  </div>
</section>

